import React, { useState } from "react";
import Box from "@mui/material/Box";
import RadialBar from "./RadialBar";
import CommonButton from "../../CommonComponents/CommonButton";
import styles from "./ageing.module.css";
import { useDispatch, useSelector } from "react-redux";
import { activeTabReducer } from "../../Redux/Slice/AgeingTabSlice";
import { useEffect } from "react";
import { ageingReports } from "../../Services/ageing.service";
import useToaster from "../../customHook/useToaster";

const ageingTabs = ["All", "VVIP", "HNI", "Red Circle", "Senior Citizen"];
export default function Ageing() {
  const [radialDataState, setRadialDataState] = useState([]);
  const dispatch = useDispatch();
  const { showToast } = useToaster();
  const activeTab = useSelector((state) => state.AgeingTabSlice.activeTab);
  const { activeTourStep } = useSelector((state) => state.appTourSlice);
  const isTourActive =
    activeTourStep === 9
      ? {
          background: "white",
          boxShadow: "0px 2px 10px 0px #FFFFFFB2",
          borderRadius: "20px",
          border: "1px solid #9F9F9F",
          padding: "8px",
        }
      : {};

  const ageingTabsButtonHandler = (activeTab) => {
    dispatch(activeTabReducer(activeTab));
  };

  const viewReportsClickHandler = () => {
    showToast("Coming Soon.", "info", true);
  };

  useEffect(() => {
    dispatch(activeTabReducer("All"));
  }, []);

  useEffect(() => {
    ageingReports()
      .then((data) => {
        setRadialDataState(data?.data?.casesTAT);
      })
      .catch((error) => {
        showToast(
          error?.response?.data?.message ||
            "Something went wrong while loading ageing report.",
          "error",
          true
        );
      });
  }, []);

  return (
    <Box
      style={{ position: "relative", height: "100%", ...isTourActive }}
      id="dash-ageing"
    >
      <div
        style={{
          position: "relative",
          height: "100%",
          paddingLeft: "1.5rem",
          paddingTop: "0.5rem",
          border: "0.1rem solid #F2F2F2",
          borderRadius: "0.67rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className={styles["ageing-header"]}>
            <h1 style={{ fontWeight: "500", fontSize: "1.7rem" }}>
              Ageing Report
            </h1>
            {/* <p style={{ fontSize: "1.3rem" }}>
              Self / <span style={{ color: "#2CB0F2" }}>Team</span>
            </p> */}
          </div>
          {/* <CommonButton
            removeBackGround
            onClick={viewReportsClickHandler}
            fitContent
            isColor
            backgroundColor={"#fff"}
            textColor={"#2CB0F2"}
            label="View Reports"
            fontSize="1.3rem"
            sx={{
              padding: "0.3rem",
              marginRight: "1.5rem",
            }}
          /> */}
        </div>

        {/* <div
          style={{
            display: "flex",
            gap: "0.5rem",
            marginLeft: "0rem",
            textAlign: "center",
            marginTop: "2.2rem",
          }}
        >
          {ageingTabs?.map((tabName, id) => (
            <div key={id}>
              <button
                id={tabName}
                disabled={tabName !== "All" ? true : false}
                style={{
                  padding: "0.5rem 1.6rem",
                  fontSize: "1.1rem",
                  borderRadius: "4px",
                  width: "100%",
                  cursor: tabName !== "All" ? "not-allowed" : "pointer",
                  outline: "none",
                  color: activeTab === tabName ? "white" : "#B1B3B5",
                  border: `1px solid ${
                    activeTab === tabName ? "#e8505b" : "#B1B3B5"
                  }`,
                  background: activeTab === tabName ? "#e8505b" : "none",
                }}
                onClick={() => ageingTabsButtonHandler(tabName)}
              >
                {tabName}
              </button>
            </div>
          ))}
        </div> */}
        <div>
          <RadialBar radialDataState={radialDataState} />
        </div>
      </div>

      {/* Overlay */}
      {/* <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
          borderRadius: "10px",
        }}
      >
        <h2 style={{ fontSize: "2rem", color: "#FFFFFF" }}>Coming Soon</h2>
      </div> */}
    </Box>
  );
}
